import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from 'src/app/_provider/auth.service';
import { StripeStatusResponse } from 'src/app/_provider/payment/payment.types';

@Component({
    selector: 'subscription-banner',
    templateUrl: './subscription-banner.component.html',
    styleUrls: ['./subscription-banner.component.scss'],
    standalone: false
})
export class SubscriptionBannerComponent {

  @Input() public statusData: StripeStatusResponse
  @Output() public onAboButtonClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public authSrv: AuthService
  ) { }


}
